import { supabase } from '../lib/supabase';

export type FunnelEvent =
  | 'signup'
  | 'email_confirm'
  | 'view_chart'
  | 'paywall_hit'
  | 'converted'
  | 'churned';

export type SystemName =
  | 'birth_chart'
  | 'forecasts'
  | 'synastry'
  | 'tarot'
  | 'numerology'
  | 'human_design'
  | 'vedic'
  | 'professional_path'
  | 'astrocartography'
  | 'dream_journal'
  | 'astro_coach'
  | 'retrograde'
  | 'eclipse'
  | 'astro_pet'
  | 'tarot_cigano'
  | 'i_ching';

export async function trackFunnelEvent(
  eventType: FunnelEvent,
  metadata: Record<string, unknown> = {}
): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    await supabase.from('user_funnel_events').insert({
      user_id: user.id,
      event_type: eventType,
      metadata,
    });
  } catch {
    // silent
  }
}

export async function trackSystemUsage(systemName: SystemName): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    await supabase.rpc('increment_system_usage', {
      p_user_id: user.id,
      p_system_name: systemName,
    });
  } catch {
    // silent
  }
}

export async function updateUserHealthScore(): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString();
    const { data: usageData } = await supabase
      .from('system_usage')
      .select('system_name')
      .eq('user_id', user.id)
      .gte('created_at', thirtyDaysAgo);

    const featuresUsed = new Set((usageData ?? []).map((d: { system_name: string }) => d.system_name)).size;
    const engagementScore = Math.min(100, featuresUsed * 10 + 20);
    const churnRisk: 'low' | 'medium' | 'high' =
      engagementScore < 30 ? 'high' : engagementScore < 60 ? 'medium' : 'low';

    await supabase.from('user_health_score').upsert({
      user_id: user.id,
      features_used_count: featuresUsed,
      engagement_score: engagementScore,
      churn_risk: churnRisk,
      last_login: new Date().toISOString().split('T')[0],
      days_since_last_login: 0,
      updated_at: new Date().toISOString(),
    });
  } catch {
    // silent
  }
}
